import { a as __rest, _ as __assign } from '../../tslib.es6-5bc94358.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React__default from 'react';
import { s as styleInject } from '../../style-inject.es-1f59c1d0.js';

var css_248z = ".styles-module_content-container__4wuQ0 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}";
var styles = {"content-container":"styles-module_content-container__4wuQ0"};
styleInject(css_248z);

var buttonTypeClassNameMap = {
    primary: 'p-btn--primary',
    secondary: 'p-btn--secondary',
    secondaryGrey: 'p-btn--secondary-grey',
    outline: 'p-btn--outline',
    outlineGrey: 'p-btn--outline-grey',
};
var Button = React__default.forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.loading, loading = _b === void 0 ? false : _b, buttonTitle = _a.buttonTitle, _c = _a.buttonType, buttonType = _c === void 0 ? 'primary' : _c, leftIcon = _a.leftIcon; _a.type; var props = __rest(_a, ["className", "loading", "buttonTitle", "buttonType", "leftIcon", "type"]);
    var buttonClassName = buttonTypeClassNameMap[buttonType];
    var loadingClassName = loading ? 'p-btn--loading' : '';
    return (jsx("button", __assign({ ref: ref, className: buttonClassName + " " + loadingClassName + " " + (className !== null && className !== void 0 ? className : '') }, props, { children: leftIcon ? (jsxs("div", __assign({ className: styles['content-container'] }, { children: [jsx("img", { width: "20px", height: "20px", className: "mr8", src: leftIcon.src, alt: leftIcon.alt }, void 0),
                jsx("div", { children: buttonTitle }, void 0)] }), void 0)) : (jsx(Fragment, { children: buttonTitle }, void 0)) }), void 0));
});

export default Button;
//# sourceMappingURL=index.js.map
